import { formatDateWithLocalTZ } from '@ticomix/common';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { IAuthUserInfoApiResponse } from './i-iauth-user-info-api-response';
import { AuthUserInfo } from './auth-user-info';
import { throwException, blobToText } from './api-utilities';



export class AuthUserInfoApiResponse implements IAuthUserInfoApiResponse {
    Success!: boolean;
    Message!: string;
    Data?: AuthUserInfo | null;
    Errors?: { [key: string]: string[]; } | null;

    constructor(data?: IAuthUserInfoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.Data = data.Data && !(<any>data.Data).toJSON ? new AuthUserInfo(data.Data) : <AuthUserInfo>this.Data;
        }
        if (!data) {
            this.Success = false;
            this.Message = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Success = _data["Success"] !== undefined ? _data["Success"] : false;
            this.Message = _data["Message"] !== undefined ? _data["Message"] : "";
            this.Data = _data["Data"] ? AuthUserInfo.fromJS(_data["Data"]) : <any>null;
            if (_data["Errors"]) {
                this.Errors = {} as any;
                for (let key in _data["Errors"]) {
                    if (_data["Errors"].hasOwnProperty(key))
                        (<any>this.Errors)![key] = _data["Errors"][key] !== undefined ? _data["Errors"][key] : [];
                }
            }
            else {
                this.Errors = <any>null;
            }
        }
    }

    static fromJS(data: any): AuthUserInfoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthUserInfoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.Success !== undefined ? this.Success : <any>null;
        data["Message"] = this.Message !== undefined ? this.Message : <any>null;
        data["Data"] = this.Data ? this.Data.toJSON() : <any>null;
        if (this.Errors) {
            data["Errors"] = {};
            for (let key in this.Errors) {
                if (this.Errors.hasOwnProperty(key))
                    (<any>data["Errors"])[key] = this.Errors[key] !== undefined ? this.Errors[key] : <any>null;
            }
        }
        return data;
    }

}